<template>
  <div class="h-full flex flex-col ">
    <!-- Header -->
    <div class="px-8 py-6 border-b border-gray-100 flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-black text-gray-900">Configuration</h2>
        <p class="text-sm text-gray-500 mt-1">Configurez l'intégralité des frais et commissions de la plateforme.</p>
      </div>
    </div>

    <!-- Form Content -->
    <div class="flex-1 overflow-y-auto p-8 custom-scrollbar">
      <form @submit.prevent="saveAll" class="space-y-8 max-w-2xl mx-auto">
        
        <!-- Delivery Section -->
        <div class="space-y-6">
          <div class="flex items-center gap-3">
            <span class="text-2xl">📦</span>
            <h3 class="text-lg font-black text-gray-900 uppercase tracking-tight">Frais de Livraison & Checkpoints</h3>
          </div>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Frais de base (FCFA)</label>
              <input type="number" v-model.number="formState.delivery.baseFee" class="form-input" />
            </div>
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Prix au kilomètre (FCFA)</label>
              <input type="number" v-model.number="formState.delivery.pricePerKm" class="form-input" />
            </div>
            
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Prix au Gramme (FCFA)</label>
              <input type="number" v-model.number="formState.delivery.pricePerG" class="form-input" />
            </div>
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Prix au Document (FCFA)</label>
              <input type="number" v-model.number="formState.delivery.pricePerDoc" class="form-input" />
            </div>

            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Frais de Pickup (FCFA)</label>
              <input type="number" v-model.number="formState.delivery.pickupFee" class="form-input" />
            </div>
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Seuil Livraison Gratuite (FCFA)</label>
              <input type="number" v-model.number="formState.delivery.freeDeliveryThreshold" class="form-input" />
            </div>
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Checkpoint Fixe (FCFA)</label>
              <input type="number" v-model.number="formState.delivery.checkPointFeeFixed" class="form-input" />
            </div>
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Checkpoint (%)</label>
              <input type="number" step="0.1" v-model.number="formState.delivery.checkPointFeePercent" class="form-input" />
            </div>
          </div>
        </div>

        <!-- Restaurant Section -->
        <div class="space-y-6 pt-4 border-t border-gray-100">
          <div class="flex items-center gap-3">
            <span class="text-2xl">🍽️</span>
            <h3 class="text-lg font-black text-gray-900 uppercase tracking-tight">Commissions Restaurant</h3>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Commission Rapidoo (%)</label>
              <input type="number" step="0.1" v-model.number="formState.restaurant.commissionRapidooPercent" class="form-input text-primary font-bold" />
            </div>
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Commission Rapidoo Fixe (FCFA)</label>
              <input type="number" v-model.number="formState.restaurant.commissionRapidooFixed" class="form-input" />
            </div>
          </div>
        </div>

        <!-- Merchant Section -->
        <div class="space-y-6 pt-4 border-t border-gray-100">
          <div class="flex items-center gap-3">
            <span class="text-2xl">🏪</span>
            <h3 class="text-lg font-black text-gray-900 uppercase tracking-tight">Commissions Marchand</h3>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Commission Rapidoo (%)</label>
              <input type="number" step="0.1" v-model.number="formState.merchant.commissionRapidooPercent" class="form-input text-primary font-bold" />
            </div>
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Commission Rapidoo Fixe (FCFA)</label>
              <input type="number" v-model.number="formState.merchant.commissionRapidooFixed" class="form-input" />
            </div>
          </div>
        </div>

        <!-- Rider Section -->
        <div class="space-y-6 pt-4 border-t border-gray-100">
          <div class="flex items-center gap-3">
            <span class="text-2xl">🛵</span>
            <h3 class="text-lg font-black text-gray-900 uppercase tracking-tight">Commissions Livreur (Rider)</h3>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Commission sur Livraison (%)</label>
              <input type="number" step="0.1" v-model.number="formState.rider.commissionOnDeliveryPercent" class="form-input text-primary font-bold" />
            </div>
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Commission sur Livraison Fixe (FCFA)</label>
              <input type="number" v-model.number="formState.rider.commissionOnDeliveryFixed" class="form-input" />
            </div>
          </div>
        </div>

        <!-- Service Section -->
        <div class="space-y-6 pt-4 border-t border-gray-100">
          <div class="flex items-center gap-3">
            <span class="text-2xl">🛡️</span>
            <h3 class="text-lg font-black text-gray-900 uppercase tracking-tight">Frais de Service</h3>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Pourcentage (%)</label>
              <input type="number" step="0.1" v-model.number="formState.service.percent" class="form-input text-primary font-bold" />
            </div>
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Frais Minimum (FCFA)</label>
              <input type="number" v-model.number="formState.service.minimumFee" class="form-input" />
            </div>
          </div>
        </div>

        <!-- Payment Providers Section -->
        <div class="space-y-6 pt-4 border-t border-gray-100">
          <div class="flex items-center gap-3">
            <span class="text-2xl">🔌</span>
            <h3 class="text-lg font-black text-gray-900 uppercase tracking-tight">Fournisseurs de Paiement</h3>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Fournisseur de collecte (Collection)</label>
              <select v-model="formState.paymentProviders.collectionProviders" class="form-input">
                <option value="fedapay">FedaPay</option>
                <option value="feexpay">FeexPay</option>
              </select>
            </div>
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Fournisseur de retrait (Withdrawal)</label>
              <select v-model="formState.paymentProviders.withdrawalProviders" class="form-input">
                <option value="fedapay">FedaPay</option>
                <option value="fedapay-pilot">FedaPay Dashboard</option>
                <option value="feexpay">FeexPay</option>
              </select>
            </div>
          </div>
        </div>

        <!-- Payout Section (Retraits Généraux) -->
        <div class="space-y-6 pt-4 border-t border-gray-100">
          <div class="flex items-center gap-3">
            <span class="text-2xl">💸</span>
            <h3 class="text-lg font-black text-gray-900 uppercase tracking-tight">Frais de Retrait (Payout)</h3>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Pourcentage (%)</label>
              <input type="number" step="0.1" v-model.number="formState.payout.percent" class="form-input text-primary font-bold" />
            </div>
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Frais Fix (FCFA)</label>
              <input type="number" v-model.number="formState.payout.fixedFee" class="form-input" />
            </div>
            <div class="space-y-2 md:col-span-2 flex items-center justify-between p-4 bg-gray-50/50 rounded-2xl border border-gray-200">
              <div>
                <label class="text-sm font-bold text-gray-900 cursor-pointer" for="applyFeeOnSrc">Appliquer les frais sur la source</label>
                <p class="text-xs text-gray-500 mt-0.5">Si activé, les frais s'ajoutent au montant prélevé du wallet. Sinon, ils sont déduits du montant reçu.</p>
              </div>
              <input type="checkbox" id="applyFeeOnSrc" v-model="formState.payout.applyFeeOnSrc" class="w-5 h-5 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer" />
            </div>
          </div>
        </div>

        <!-- Payout Rider Section -->
        <div class="space-y-6 pt-4 border-t border-gray-100">
          <div class="flex items-center gap-3">
            <span class="text-2xl">🛵</span>
            <h3 class="text-lg font-black text-gray-900 uppercase tracking-tight">Frais de Retrait - Livreur (Payout Rider)</h3>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Pourcentage (%)</label>
              <input type="number" step="0.1" v-model.number="formState.payoutRider.percent" class="form-input text-primary font-bold" />
            </div>
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Frais Fix (FCFA)</label>
              <input type="number" v-model.number="formState.payoutRider.fixedFee" class="form-input" />
            </div>
            <div class="space-y-2 md:col-span-2 flex items-center justify-between p-4 bg-gray-50/50 rounded-2xl border border-gray-200">
              <div>
                <label class="text-sm font-bold text-gray-900 cursor-pointer" for="applyFeeOnSrcRider">Appliquer les frais sur la source</label>
              </div>
              <input type="checkbox" id="applyFeeOnSrcRider" v-model="formState.payoutRider.applyFeeOnSrc" class="w-5 h-5 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer" />
            </div>
          </div>
        </div>

        <!-- Payout Restaurant Section -->
        <div class="space-y-6 pt-4 border-t border-gray-100">
          <div class="flex items-center gap-3">
            <span class="text-2xl">🍽️</span>
            <h3 class="text-lg font-black text-gray-900 uppercase tracking-tight">Frais de Retrait - Restaurant</h3>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Pourcentage (%)</label>
              <input type="number" step="0.1" v-model.number="formState.payoutRestaurant.percent" class="form-input text-primary font-bold" />
            </div>
            <div class="space-y-2">
              <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Frais Fix (FCFA)</label>
              <input type="number" v-model.number="formState.payoutRestaurant.fixedFee" class="form-input" />
            </div>
            <div class="space-y-2 md:col-span-2 flex items-center justify-between p-4 bg-gray-50/50 rounded-2xl border border-gray-200">
              <div>
                <label class="text-sm font-bold text-gray-900 cursor-pointer" for="applyFeeOnSrcRestaurant">Appliquer les frais sur la source</label>
              </div>
              <input type="checkbox" id="applyFeeOnSrcRestaurant" v-model="formState.payoutRestaurant.applyFeeOnSrc" class="w-5 h-5 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer" />
            </div>
          </div>
        </div>

        <!-- Amount Limits Section -->
        <div class="space-y-6 pt-4 border-t border-gray-100">
          <div class="flex items-center gap-3">
            <span class="text-2xl">📊</span>
            <h3 class="text-lg font-black text-gray-900 uppercase tracking-tight">Limites de Montant pour Retraits (FCFA)</h3>
          </div>
          
          <!-- Limits: General Payout -->
          <div class="space-y-3 p-4 bg-gray-50/50 rounded-2xl border border-gray-200">
            <h4 class="text-sm font-bold text-gray-900">Retrait Général</h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="space-y-1">
                <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Montant Min</label>
                <input type="number" v-model.number="formState.amountLimits.payout.min" class="form-input" />
              </div>
              <div class="space-y-1">
                <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Montant Max</label>
                <input type="number" v-model.number="formState.amountLimits.payout.max" class="form-input" />
              </div>
            </div>
          </div>

          <!-- Limits: Rider Payout -->
          <div class="space-y-3 p-4 bg-gray-50/50 rounded-2xl border border-gray-200">
            <h4 class="text-sm font-bold text-gray-900">Retrait Livreur</h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="space-y-1">
                <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Montant Min</label>
                <input type="number" v-model.number="formState.amountLimits.payoutRider.min" class="form-input" />
              </div>
              <div class="space-y-1">
                <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Montant Max</label>
                <input type="number" v-model.number="formState.amountLimits.payoutRider.max" class="form-input" />
              </div>
            </div>
          </div>

          <!-- Limits: Restaurant Payout -->
          <div class="space-y-3 p-4 bg-gray-50/50 rounded-2xl border border-gray-200">
            <h4 class="text-sm font-bold text-gray-900">Retrait Restaurant</h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="space-y-1">
                <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Montant Min</label>
                <input type="number" v-model.number="formState.amountLimits.payoutRestaurant.min" class="form-input" />
              </div>
              <div class="space-y-1">
                <label class="text-xs font-bold text-gray-500 uppercase tracking-wider">Montant Max</label>
                <input type="number" v-model.number="formState.amountLimits.payoutRestaurant.max" class="form-input" />
              </div>
            </div>
          </div>
        </div>

      </form>
    </div>

    <!-- Footer Actions -->
    <div class="px-8 py-6 border-t border-gray-100 bg-gray-50/50 flex gap-4">
      <button
        @click="$emit('cancel')"
        class="flex-1 px-6 py-4 rounded-2xl bg-white border border-gray-200 text-gray-600 font-bold hover:bg-gray-100 transition-all"
      >
        Annuler
      </button>
      <button
        @click="saveAll"
        :disabled="isSaving"
        class="flex-[2] px-6 py-4 rounded-2xl bg-primary text-white font-bold shadow-lg shadow-primary/20 hover:scale-[1.02] active:scale-[0.98] transition-all disabled:opacity-50 disabled:grayscale"
      >
        <span v-if="!isSaving">Enregistrer les modifications</span>
        <span v-else class="flex items-center justify-center gap-2">
          <LoaderIcon class="w-5 h-5 animate-spin" />
          Enregistrement...
        </span>
      </button>
    </div>

    <!-- Triggers -->
    <ActionTrigger
      dataKey="saveFeesConfig"
      ref="saveTrigger"
      @success="onSuccess"
      @failed="onError"
    />
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, h } from 'vue'
import ActionTrigger from '@/features/data/presentation/components/ActionTrigger.vue'
import Events from '@/events/events'
import { EVENTS } from '@/shared/constants/commons'

// Internal SVG Components
const XIcon = (props) => h('svg', { 
  ...props, 
  xmlns: 'http://www.w3.org/2000/svg', 
  viewBox: '0 0 24 24', 
  fill: 'none', 
  stroke: 'currentColor', 
  'stroke-width': '2', 
  'stroke-linecap': 'round', 
  'stroke-linejoin': 'round' 
}, [
  h('line', { x1: '18', y1: '6', x2: '6', y2: '18' }),
  h('line', { x1: '6', y1: '6', x2: '18', y2: '18' })
])

const LoaderIcon = (props) => h('svg', { 
  ...props, 
  xmlns: 'http://www.w3.org/2000/svg', 
  viewBox: '0 0 24 24', 
  fill: 'none', 
  stroke: 'currentColor', 
  'stroke-width': '2', 
  'stroke-linecap': 'round', 
  'stroke-linejoin': 'round' 
}, [
  h('path', { d: 'M21 12a9 9 0 1 1-6.219-8.56' })
])

const props = defineProps({
  feesData: { type: Object, default: () => ({}) }
})

const emit = defineEmits(['saved', 'cancel'])

const saveTrigger = ref(null)
const isSaving = ref(false)

const formState = reactive({
  delivery: {
    baseFee: 0,
    pickupFee: 0,
    pricePerKm: 0,
    pricePerG: 0,
    pricePerDoc: 0,
    freeDeliveryThreshold: 0,
    checkPointFeeFixed: 0,
    checkPointFeePercent: 0
  },
  restaurant: {
    commissionRapidooPercent: 0,
    commissionRapidooFixed: 0
  },
  merchant: {
    commissionRapidooPercent: 0,
    commissionRapidooFixed: 0
  },
  rider: {
    commissionOnDeliveryPercent: 0,
    commissionOnDeliveryFixed: 0
  },
  service: {
    percent: 0,
    minimumFee: 0
  },
  payout: {
    percent: 0,
    fixedFee: 0,
    applyFeeOnSrc: false
  },
  payoutRider: {
    percent: 0,
    fixedFee: 0,
    applyFeeOnSrc: false
  },
  payoutRestaurant: {
    percent: 0,
    fixedFee: 0,
    applyFeeOnSrc: false
  },
  paymentProviders: {
    collectionProviders: "fedapay",
    withdrawalProviders: "fedapay"
  },
  amountLimits: {
    payout: {
      min: 0,
      max: 10000
    },
    payoutRider: {
      min: 0,
      max: 10000
    },
    payoutRestaurant: {
      min: 0,
      max: 10000
    }
  }
})

onMounted(() => {
  if (props.feesData) {
    if (props.feesData.delivery) Object.assign(formState.delivery, props.feesData.delivery)
    if (props.feesData.restaurant) Object.assign(formState.restaurant, props.feesData.restaurant)
    if (props.feesData.merchant) Object.assign(formState.merchant, props.feesData.merchant)
    if (props.feesData.rider) Object.assign(formState.rider, props.feesData.rider)
    if (props.feesData.service) Object.assign(formState.service, props.feesData.service)
    if (props.feesData.payout) Object.assign(formState.payout, props.feesData.payout)
    if (props.feesData.payoutRider) Object.assign(formState.payoutRider, props.feesData.payoutRider)
    if (props.feesData.payoutRestaurant) Object.assign(formState.payoutRestaurant, props.feesData.payoutRestaurant)
    if (props.feesData.paymentProviders) Object.assign(formState.paymentProviders, props.feesData.paymentProviders)
    if (props.feesData.amountLimits) {
      if (props.feesData.amountLimits.payout) Object.assign(formState.amountLimits.payout, props.feesData.amountLimits.payout)
      if (props.feesData.amountLimits.payoutRider) Object.assign(formState.amountLimits.payoutRider, props.feesData.amountLimits.payoutRider)
      if (props.feesData.amountLimits.payoutRestaurant) Object.assign(formState.amountLimits.payoutRestaurant, props.feesData.amountLimits.payoutRestaurant)
    }
  }
})

function saveAll() {
  isSaving.value = true
  saveTrigger.value.trigger({
    config: { ...formState }
  })
}

function onSuccess() {
  isSaving.value = false
  Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
    title: 'Configuration Enregistrée',
    body: 'Toutes les modifications économiques ont été appliquées avec succès.',
    type: 'success'
  })
  emit('saved')
}

function onError(err) {
  isSaving.value = false
  Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
    title: "Échec de l'enregistrement",
    body: err.result?.message || 'Une erreur est survenue lors de la sauvegarde.',
    type: 'error'
  })
}
</script>

<style scoped>
.form-input {
  @apply w-full rounded-2xl border border-gray-200 bg-gray-50/50 px-5 py-3.5 text-sm 
         text-gray-900 transition-all focus:border-primary focus:bg-white focus:outline-none 
         focus:ring-4 focus:ring-primary/10 font-medium;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #e5e7eb;
  border-radius: 10px;
}
</style>